import { useNavigate } from "react-router";
import { resetBootstrap } from "@/app/bootstrap";
import { t } from "@/i18n/ko";
import { StatusPage } from "./StatusPage";

/** 1.0 ①: app/settings 실패 + persist 캐시 없음 → F09-01 네트워크 끊김(91:3343) 풀페이지, [다시 시도] → 부트스트랩 재실행. */
export function BootstrapErrorPage() {
  const navigate = useNavigate();
  return (
    <StatusPage
      icon="cat"
      title={t("error.bootstrap.title")}
      description={t("error.bootstrap.body")}
      cta={t("common.retry")}
      onCta={() => {
        resetBootstrap();
        navigate("/", { replace: true });
      }}
      testId="bootstrap-error"
    />
  );
}
